export default __webpack_public_path__ + "static/media/gwn13.ab6267a5.webp";